import { createFileRoute } from '@tanstack/react-router';
import { PurchasePage, validateNewPurchaseSearch } from '@/components/purchases/purchase-page';

export const Route = createFileRoute('/expenses/purchase-orders/new')({
  component: New,
  validateSearch: validateNewPurchaseSearch,
});

/** Screen E10 (document 06): a new purchase order. */
function New() {
  const s = Route.useSearch();
  return <PurchasePage kind="purchase_order" {...s} />;
}
